import { useQuery } from "react-query";
import inventoryClient from "../clients/inventoryClient";

function useReportingOverview(establishmentId) {
    const queryReturnValues = useQuery(
        ["reporting-overview", { establishmentId }],
        inventoryClient.getReportingOverview,
        {
            staleTime: 1000 * 60 * 3
        }
    );

   return queryReturnValues;
}

export default useReportingOverview;